import API from "./../../utils/GlobalAPI";
import { getOrderByUserId, countOrdersByUserId } from "../Order/OrderAPI";
import { CourseProp } from "./CourseType";
import { countProjectsByUserId } from "../Project/ProjectAPI";
import * as Storage from "ts-storage";
import { decodeToken } from "../../utils/tokenAPI";

export async function getCourses() {
  try {
    const courses: any = await API.getMethod("courses");

    let fallback = "nothing";
    let token = Storage.get("token", fallback).value;

    if (token !== fallback) {
      const { userId } = decodeToken(token);
      const enrolled_courses: any = await getEnrolledCourseByUserId(userId);

      courses.forEach((course: any) => {
        enrolled_courses.forEach((enrolled_course: any) => {
          if (course.id === enrolled_course.id) {
            course.enrolled = true;
          }
        });
      });
    }

    return courses;
  } catch (err) {
    return null;
  }
}

export async function getCoursebyIds(coursesId: Array<string>) {
  try {
    const promises = coursesId.map((id) => {
      return API.getMethod(`courses/${id}`);
    });

    const data = await Promise.all(promises);
    return data;
  } catch (err) {
    return null;
  }
}

export async function getCourseBySlug(slug: string) {
  try {
    const data: any = await API.getMethod(`courses?slug=${slug}`);
    return data[0];
  } catch (err) {
    return null;
  }
}

export async function getLimitCourse(limit: string) {
  try {
    const data: any = await API.getMethod(`courses?_limit=${limit}`);

    let fallback = "nothing";
    let token = Storage.get("token", fallback).value;

    if (token !== fallback) {
      const { userId } = decodeToken(token);
      const enrolled_courses: any = await getEnrolledCourseByUserId(userId);

      data.forEach((course: any) => {
        enrolled_courses.forEach((enrolled_course: any) => {
          if (course.id === enrolled_course.id) {
            course.enrolled = true;
          }
        });
      });
    }

    return data;
  } catch (err) {
    return null;
  }
}

export async function getCategories() {
  try {
    const data = await API.getMethod("categories");
    return data;
  } catch (err) {
    return null;
  }
}

export async function getCategoryByParam(param: string, value: string) {
  try {
    const data = await API.getMethod(`categories?${param}=${value}`);
    return data;
  } catch (err) {
    return null;
  }
}

export async function getCoursesBySlugCategory(slug: string) {
  try {
    const data: any = await API.getMethod(
      `courses?_where[0][category.slug]=${slug}`
    );

    return data;
  } catch (err) {
    return null;
  }
}

export async function getEnrolledCourseByUserId(userId: string) {
  try {
    const orderdata: any = await getOrderByUserId(userId);
    let orders = [...orderdata];
    let enrolled: Array<CourseProp> = [];
    orders.forEach((order) => {
      if (order.status) {
        order.courses.forEach((course: CourseProp) => {
          enrolled.push(course);
        });
      }
    });
    return enrolled;
  } catch (err) {
    return null;
  }
}

export async function countEnrolledCourseByUserId(userId: string) {
  try {
    const data: any = await getEnrolledCourseByUserId(userId);
    return data.length;
  } catch (err) {
    console.log(err);
    return null;
  }
}

export async function getStatisticsByUserId(userId: string) {
  try {
    const data = await Promise.all([
      countEnrolledCourseByUserId(userId),
      countProjectsByUserId(userId),
      countOrdersByUserId(userId),
    ]);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}
